import { Injectable } from '@angular/core';

import { ZipCodeInfo } from '../interfaces/country-info.interface';

@Injectable()
export class ZipCodeService {
  private zipCodesInfo: Map<string, ZipCodeInfo> = new Map([
    ['AX', { zipCodeFormat: /^(AX-)?22\d{3}$/, zipCodeSample: '22550' }],
    ['DZ', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '36330' }],
    ['AS', { zipCodeFormat: /^96799$/, zipCodeSample: '96799' }],
    ['AD', { zipCodeFormat: /^AD\d{3}$/, zipCodeSample: 'AD500' }],
    ['AI', { zipCodeFormat: /^AI-2640$/, zipCodeSample: 'AI-2640' }],
    [
      'AR',
      {
        zipCodeFormat: /^([A-HJ-NP-Z])?\d{4}([A-Z]{3})?$/,
        zipCodeSample: 'C1124',
      },
    ],
    ['AM', { zipCodeFormat: /^(37)?\d{4}$/, zipCodeSample: '1916' }],
    ['AU', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '2618' }],
    ['AT', { zipCodeFormat: /^(?!0)\d{4}$/, zipCodeSample: '1001' }],
    ['AZ', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '1005' }],
    ['BH', { zipCodeFormat: /^((1[0-2]|[2-9])\d{2})?$/, zipCodeSample: '1101' }],
    ['BD', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '1208' }],
    ['BB', { zipCodeFormat: /^(BB\d{5})?$/, zipCodeSample: 'BB15028' }],
    ['BY', { zipCodeFormat: /^\d{6}$/, zipCodeSample: '220141' }],
    ['BE', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '1033' }],
    ['BM', { zipCodeFormat: /^[A-Z]{2}[ ]?[A-Z0-9]{2}$/, zipCodeSample: 'CR 01' }],
    ['BA', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '78000' }],
    ['BR', { zipCodeFormat: /^\d{5}[-]?\d{3}$/, zipCodeSample: '47834-812' }],
    ['AQ', { zipCodeFormat: /^BIQQ 1ZZ$/, zipCodeSample: 'BIQQ 1ZZ' }],
    ['IO', { zipCodeFormat: /^BBND 1ZZ$/, zipCodeSample: 'BBND 1ZZ' }],
    ['BN', { zipCodeFormat: /^[A-Z]{2}[ ]?\d{4}$/, zipCodeSample: 'BE1318' }],
    ['BG', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '2110' }],
    ['KH', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '12310' }],
    [
      'CA',
      {
        zipCodeFormat: /^([ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ])\s*([0-9][ABCEGHJKLMNPRSTVWXYZ][0-9])$/,
        zipCodeSample: 'K1A0B1',
      },
    ],
    ['CV', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '3133' }],
    ['CL', { zipCodeFormat: /^\d{7}$/, zipCodeSample: '8150215' }],
    ['CN', { zipCodeFormat: /^\d{6}$/, zipCodeSample: '610000' }],
    ['CX', { zipCodeFormat: /^6798$/, zipCodeSample: '6798' }],
    ['CC', { zipCodeFormat: /^6799$/, zipCodeSample: '6799' }],
    ['CR', { zipCodeFormat: /^\d{4,5}|\d{3}-\d{4}$/, zipCodeSample: '11801' }],
    ['HR', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '10000' }],
    ['CU', { zipCodeFormat: /^CP[ ]?\d{5}$/, zipCodeSample: 'CP 10600' }],
    ['CY', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '2822' }],
    ['CZ', { zipCodeFormat: /^\d{3}[ ]?\d{2}$/, zipCodeSample: '147 00' }],
    ['DK', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '6100' }],
    ['DO', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '10215' }],
    [
      'EC',
      {
        zipCodeFormat: /^([A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?$/,
        zipCodeSample: '170153',
      },
    ],
    ['SV', { zipCodeFormat: /^CP[ ]?\d{4}$/, zipCodeSample: 'CP 1101' }],
    ['EG', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '42534' }],
    ['EE', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '10115' }],
    ['ET', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '1150' }],
    ['FK', { zipCodeFormat: /^FIQQ 1ZZ$/, zipCodeSample: 'FIQQ 1ZZ' }],
    ['FO', { zipCodeFormat: /^\d{3}$/, zipCodeSample: '335' }],
    ['FI', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '00100' }],
    ['FR', { zipCodeFormat: /^\d{2}[ ]?\d{3}$/, zipCodeSample: '75 008' }],
    ['GF', { zipCodeFormat: /^9[78]3\d{2}$/, zipCodeSample: '97319' }],
    ['PF', { zipCodeFormat: /^987\d{2}$/, zipCodeSample: '98715' }],
    ['GE', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '30002' }],
    ['DE', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '20095' }],
    ['GI', { zipCodeFormat: /^GX11 1AA$/, zipCodeSample: 'GX11 1AA' }],
    ['GR', { zipCodeFormat: /^\d{3}[ ]?\d{2}$/, zipCodeSample: '104 33' }],
    ['GL', { zipCodeFormat: /^39\d{2}$/, zipCodeSample: '3905' }],
    ['GP', { zipCodeFormat: /^9[78][01]\d{2}$/, zipCodeSample: '97139' }],
    [
      'GU',
      {
        zipCodeFormat: /^969([1-2][0-9]|3[0-2])([-]\d{4})?$/,
        zipCodeSample: '96910',
      },
    ],
    ['GT', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '01001' }],
    [
      'GG',
      {
        zipCodeFormat: /^GY\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
        zipCodeSample: 'GY1 2NU',
      },
    ],
    ['GN', { zipCodeFormat: /^\d{3}$/, zipCodeSample: '001' }],
    ['GW', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '1000' }],
    ['HT', { zipCodeFormat: /^([H]?[T]?)\d{4}$/, zipCodeSample: 'HT 6120' }],
    ['HN', { zipCodeFormat: /^(?:\d{5})?$/, zipCodeSample: '21101' }],
    ['HU', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '3000' }],
    ['IS', { zipCodeFormat: /^\d{3}$/, zipCodeSample: '105' }],
    ['IN', { zipCodeFormat: /^\d{6}$/, zipCodeSample: '560011' }],
    ['ID', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '50614' }],
    ['IR', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '25529' }],
    ['IQ', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '10081' }],
    [
      'IM',
      {
        zipCodeFormat: /^IM\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
        zipCodeSample: 'IM1 1AG',
      },
    ],
    ['IL', { zipCodeFormat: /^\d{7}$/, zipCodeSample: '9084500' }],
    ['IT', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '20090' }],
    ['JM', { zipCodeFormat: /^\d{2}$/, zipCodeSample: '18' }],
    ['JP', { zipCodeFormat: /^\d{3}-\d{4}$/, zipCodeSample: '203-0000' }],
    [
      'JE',
      {
        zipCodeFormat: /^JE\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
        zipCodeSample: 'JE3 9GB',
      },
    ],
    ['JO', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '11110' }],
    ['KZ', { zipCodeFormat: /^\d{6}$/, zipCodeSample: '161206' }],
    ['KE', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '00100' }],
    ['XK', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '30001' }],
    ['KW', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '11801' }],
    ['KG', { zipCodeFormat: /^\d{6}$/, zipCodeSample: '720001' }],
    ['LA', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '01160' }],
    ['LV', { zipCodeFormat: /^LV-\d{4}$/, zipCodeSample: 'LV-6756' }],
    ['LB', { zipCodeFormat: /^(\d{4}([ ]?\d{4})?)?$/, zipCodeSample: '2038 3054' }],
    ['LS', { zipCodeFormat: /^\d{3}$/, zipCodeSample: '345' }],
    ['LR', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '1101' }],
    ['LI', { zipCodeFormat: /^(948[5-9])|(949[0-7])$/, zipCodeSample: '9487' }],
    ['LT', { zipCodeFormat: /^LT-\d{5}$/, zipCodeSample: 'LT-00930' }],
    ['LU', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '1010' }],
    ['MK', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '1200' }],

    ['MG', { zipCodeFormat: /^\d{3}$/, zipCodeSample: '101' }],
    ['MY', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '50450' }],
    ['MV', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '9487' }],
    ['MT', { zipCodeFormat: /^[A-Z]{3}[ ]?\d{2,4}$/, zipCodeSample: 'VLT 1117' }],
    ['MH', { zipCodeFormat: /^969[67]\d([ -]\d{4})?$/, zipCodeSample: '96960' }],
    ['MQ', { zipCodeFormat: /^972\d{2}$/, zipCodeSample: '97256' }],
    ['MU', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '42602' }],
    ['YT', { zipCodeFormat: /^976\d{2}$/, zipCodeSample: '97634' }],
    ['MX', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '46958' }],
    ['FM', { zipCodeFormat: /^(9694[1-4])([ -]\d{4})?$/, zipCodeSample: '96941' }],
    ['MD', { zipCodeFormat: /^MD[-]?\d{4}$/, zipCodeSample: 'MD-2001' }],
    ['MC', { zipCodeFormat: /^980(0[0-9]|[1-9][0-9])$/, zipCodeSample: '98045' }],
    ['MN', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '15141' }],
    ['ME', { zipCodeFormat: /^8\d{4}$/, zipCodeSample: '81101' }],
    [
      'MS',
      {
        zipCodeFormat: /^MSR[ ]?1(?:1(10|[1-9][0-9])|2[0-9][0-9]|3([0-4][0-9]|50))$/,
        zipCodeSample: 'MSR 1110',
      },
    ],
    ['MA', { zipCodeFormat: /^\d{2}[ ]?\d{3}$/, zipCodeSample: '61 000' }],
    ['MZ', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '1119' }],
    ['MM', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '06111' }],
    ['NP', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '10700' }],
    ['NL', { zipCodeFormat: /^\d{4}[ ]?[A-Z]{2}$/, zipCodeSample: '1000 AP' }],
    ['NC', { zipCodeFormat: /^988(0[0-9]|[1-8][0-9]|90)$/, zipCodeSample: '98847' }],
    ['NZ', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '0114' }],
    ['NI', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '10000' }],
    ['NE', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '8001' }],
    ['NG', { zipCodeFormat: /^\d{6}$/, zipCodeSample: '460001' }],
    ['NF', { zipCodeFormat: /^2899$/, zipCodeSample: '2899' }],
    ['MP', { zipCodeFormat: /^9695[012]([ -]\d{4})?$/, zipCodeSample: '96950' }],
    [
      'NO',
      {
        zipCodeFormat:
          /^(000[1-9]|[1-8][0-9]|9[0-9]|[1-8][0-9]{2}|9[0-8][0-9]|99[0-9]|[1-8][0-9]{3}|9[0-8][0-9]{2}|99[0-8][0-9]|999[01])$/,
        zipCodeSample: '4567',
      },
    ],
    ['OM', { zipCodeFormat: /^\d{3}$/, zipCodeSample: '133' }],
    ['PK', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '24550' }],
    ['PW', { zipCodeFormat: /^96940$/, zipCodeSample: '96940' }],
    ['PS', { zipCodeFormat: /^([1-9][0-9]{2})$/, zipCodeSample: '899' }],
    ['PA', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '0101' }],
    ['PG', { zipCodeFormat: /^\d{3}$/, zipCodeSample: '121' }],
    ['PY', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '8150' }],
    ['PE', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '07026' }],
    ['PH', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '5709' }],
    ['PN', { zipCodeFormat: /^PCRN 1ZZ$/, zipCodeSample: 'PCRN 1ZZ' }],
    ['PL', { zipCodeFormat: /^\d{2}-\d{3}$/, zipCodeSample: '00-001' }],
    ['PT', { zipCodeFormat: /^\d{4}|\d{4}-\d{3}$/, zipCodeSample: '4099' }],
    [
      'PR',
      {
        zipCodeFormat: /^00[679]\d{2}([ -]\d{4})?$/,
        zipCodeSample: '00716-2604',
      },
    ],
    ['RE', { zipCodeFormat: /^974([0-8][0-9]|90)$/, zipCodeSample: '97467' }],
    ['RO', { zipCodeFormat: /^\d{6}$/, zipCodeSample: '019999' }],
    ['RU', { zipCodeFormat: /^\d{6}$/, zipCodeSample: '191028' }],
    ['BL', { zipCodeFormat: /^97133$/, zipCodeSample: '97133' }],
    ['SH', { zipCodeFormat: /^(ASCN|STHL) 1ZZ$/, zipCodeSample: 'ASCN 1ZZ' }],
    ['LC', { zipCodeFormat: /^LC\d{2} \d{3}$/, zipCodeSample: 'LC05 201' }],
    ['MF', { zipCodeFormat: /^97150$/, zipCodeSample: '97150' }],
    ['PM', { zipCodeFormat: /^97500$/, zipCodeSample: '97500' }],
    ['VC', { zipCodeFormat: /^VC\d{4}$/, zipCodeSample: 'VC0100' }],
    ['WS', { zipCodeFormat: /^WS\d{4}$/, zipCodeSample: 'WS1382' }],
    ['SM', { zipCodeFormat: /^4789[0-9]$/, zipCodeSample: '47891' }],
    ['SA', { zipCodeFormat: /^\d{5}(-\d{4})?$/, zipCodeSample: '11543' }],
    ['SN', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '12500' }],
    ['RS', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '37230' }],
    ['SG', { zipCodeFormat: /^\d{2}|\d{4}|\d{6}$/, zipCodeSample: '339696' }],
    ['SK', { zipCodeFormat: /^\d{3}[ ]?\d{2}$/, zipCodeSample: '811 02' }],
    ['SI', { zipCodeFormat: /^([A-Z]{2})?\d{4}$/, zipCodeSample: '5270' }],
    ['SO', { zipCodeFormat: /^([A-Z]{2})[ ]\d{5}$/, zipCodeSample: 'JH 09010' }],
    ['ZA', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '0002' }],
    ['KR', { zipCodeFormat: /^\d{3}[-]\d{3}|\d{5}$/, zipCodeSample: '01034' }],
    ['ES', { zipCodeFormat: /^([0-4][1-9]|5[0-2])\d{3}$/, zipCodeSample: '03000' }],
    ['LK', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '01400' }],
    ['SD', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '79371' }],
    ['SJ', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '9178' }],
    ['SZ', { zipCodeFormat: /^[HLMS]\d{3}$/, zipCodeSample: 'H100' }],
    [
      'SE',
      {
        zipCodeFormat: /^(([1-8][0-9]{2}|9[0-7][0-9]|98[0-4]))[ ]?(0[0-9]|[1-9][0-9])$/,
        zipCodeSample: '984 98',
      },
    ],
    ['CH', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '9488' }],
    ['TW', { zipCodeFormat: /^\d{3}(\d{2})?$/, zipCodeSample: '330' }],
    ['TJ', { zipCodeFormat: /^\d{6}$/, zipCodeSample: '735450' }],
    ['TZ', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '10084' }],
    ['TH', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '10330' }],
    ['TT', { zipCodeFormat: /^\d{6}$/, zipCodeSample: '150110' }],
    ['TN', { zipCodeFormat: /^\d{4}$/, zipCodeSample: '3200' }],
    ['TR', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '28393' }],
    ['TM', { zipCodeFormat: /^\d{6}$/, zipCodeSample: '746140' }],
    ['TC', { zipCodeFormat: /^TKCA 1ZZ$/, zipCodeSample: 'TKCA 1ZZ' }],
    ['UA', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '11801' }],
    [
      'GB',
      {
        zipCodeFormat: /^([A-Z][0-9]([0-9]|[A-Z])?|[A-Z]{2}[0-9]([0-9]|[A-Z])?|[A-Z]{3})([ ][0-9][A-Z]{2})?$/,
        zipCodeSample: 'DN55 1PT',
      },
    ],
    [
      'US',
      {
        zipCodeFormat: /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/,
        zipCodeSample: '09498-0048',
      },
    ],
    ['UM', { zipCodeFormat: /^96898$/, zipCodeSample: '96898' }],
    ['UY', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '11400' }],
    [
      'VI',
      {
        zipCodeFormat: /^008([0-9][0-4]|5[0-1])([ -]\d{4})?$/,
        zipCodeSample: '',
      },
    ],
    ['UZ', { zipCodeFormat: /^\d{6}$/, zipCodeSample: '100131' }],
    ['VA', { zipCodeFormat: /^00120$/, zipCodeSample: '00120' }],
    ['VE', { zipCodeFormat: /^\d{4}([ -][A-Z])?$/, zipCodeSample: '1073' }],
    ['VN', { zipCodeFormat: /^\d{6}$/, zipCodeSample: '170000' }],
    ['WF', { zipCodeFormat: /^986([0-8][0-9]|90)$/, zipCodeSample: '986NN' }],
    ['ZM', { zipCodeFormat: /^\d{5}$/, zipCodeSample: '50100' }],
  ]);

  public getZipCodeInfo(iso: string): ZipCodeInfo {
    return this.zipCodesInfo.get(iso);
  }
}
